/**
 * Mappers for Team list. No typeof/Array.isArray in components.
 */

import { getListFromApiResponse } from "../utils/apiListMappers";

export { getListFromApiResponse };

/** Status badge class for team table. */
function getTeamStatusColor(status) {
  switch (String(status ?? "").toLowerCase()) {
    case "active":
      return "bg-badge-success";
    case "in-active":
    case "inactive":
      return "bg-badge-danger";
    default:
      return "bg-badge-secondary";
  }
}

/** Normalize API/UI status to labels: Active | Inactive */
function formatTeamStatusLabel(status) {
  const s = String(status ?? "").trim();
  if (!s) return "Active";
  const compact = s.toUpperCase().replace(/[-_\s]/g, "");
  if (compact === "ACTIVE") return "Active";
  if (compact === "INACTIVE") return "Inactive";
  return s;
}

/**
 * One mapper for Team table listing: returns display-ready values with ?? fallbacks.
 */
export function mapTeamToTableRow(team) {
  const rawStatus = team?.status;
  return {
    teamName: team?.teamName ?? team?.name ?? "N/A",
    status: formatTeamStatusLabel(rawStatus),
    statusColorClass: getTeamStatusColor(rawStatus),
  };
}
